export enum SkillCategoryEnum {
  LICENSE = "LICENSE",
  SPORT = "SPORT",
  MUSIC = "MUSIC",
  DANCE = "DANCE",
}

export enum SkillNameEnum {
  CAR = "CAR",
  MOTORCYCLE = "MOTORCYCLE",

  SOCCER = "SOCCER",
  GYMNASTICS = "GYMNASTICS",
  MARTIAL_ARTS = "MARTIAL_ARTS",
  SWIMMING = "SWIMMING",
  TENNIS = "TENNIS",
  OTHER = "OTHER",

  SINGING = "SINGING",
  DRUMS = "DRUMS",
  PIANO_KEYBOARD = "PIANO_KEYBOARD",
  GUITAR = "GUITAR",

  CLASSICAL_BALLET = "CLASSICAL_BALLET",
  CONTEMPORARY_DANCE = "CONTEMPORARY_DANCE",
  HIP_HOP = "HIP_HOP",
  BREAKDANCE = "BREAKDANCE",
  STREET_DANCE = "STREET_DANCE",
  VOGUE = "VOGUE",
  TAP_DANCE = "TAP_DANCE",
  FUNK = "FUNK",
  PASSINHO = "PASSINHO",
}

export enum DriverLicenseEnum {
  CAR = "Carro",
  MOTORCYCLE = "Moto",
}

export enum SportsEnum {
  SOCCER = "Futebol",
  GYMNASTICS = "Ginástica",
  MARTIAL_ARTS = "Luta/Arte Marcial",
  SWIMMING = "Natação",
  TENNIS = "Tênis",
  OTHER = "Outro",
}

export enum MusicEnum {
  SINGING = "Canto",
  DRUMS = "Bateria",
  PIANO_KEYBOARD = "Piano/Teclado",
  GUITAR = "Violão/Guitarra",
  OTHER = "Outro",
}

export enum DanceEnum {
  CLASSICAL_BALLET = "Ballet Clássico",
  CONTEMPORARY_DANCE = "Dança contemporânea",
  HIP_HOP = "Hip Hop",
  BREAKDANCE = "Break",
  STREET_DANCE = "Street",
  VOGUE = "Vogue",
  TAP_DANCE = "Sapateado",
  FUNK = "Funk",
  PASSINHO = "Passinho",
  OTHER = "Outro",
}
